import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import EditRentalAddOnForm from './Form'
import type { RentRollAddOn } from '../index'

type EditRentalAddOnModalProps = {
  addOn: RentRollAddOn
  close: () => void
  isOpen: boolean
  onSuccess?: () => void
  occupancyDate: string
}

export default function EditRentalAddOnModal({
  addOn,
  close,
  isOpen,
  onSuccess,
  occupancyDate
}: EditRentalAddOnModalProps) {
  return (
    <Modal toggle={close} isOpen={isOpen}>
      <ModalHeader toggle={close}>Edit Rental Add-On</ModalHeader>
      <ModalBody>
        {isOpen && (
          <EditRentalAddOnForm
            addOn={addOn}
            close={close}
            onSuccess={onSuccess}
            occupancyDate={occupancyDate}
          />
        )}
      </ModalBody>
    </Modal>
  )
}
